//
//
//
//

export default {
  name: 'rb-dummy-skeleton',
  props: {
    icon: {
      type: String,
      default: '',
    },
  },
  computed: {
    renderIcon() {
      return this.icon ? `--${this.icon}` : ''
    },
  },
}
